const headerDataHistory = [
  {
    prop: "HPName",
    label: "医院名称",
    columnwidth: 270,
  },
  {
    prop: "OperateTime",
    label: "更新时间",
    columnwidth: 240,
  },
  {
    prop: "ContentText",
    label: "变更内容",
    columnwidth: 438,
  },
];
export default headerDataHistory
